import React, { useState, useEffect } from 'react';

import { CircularProgress, Snackbar, Alert, Button } from '@mui/material';

import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useErrorManager from "../../hooks/useErrorManager";

import PageContainer from '../Layout/PageContainer';
import GenericTable from '../Layout/Table/GenericTable';
import TextFilter from "../Layout/Table/TextFilter"


function GatewaysTable( {listOptions, columns} ) {
    const [gateways, setGateways] = useState([]);
    const [filterText, setFilterText] = useState("");

    const [loading, setLoading] = useState(true);
    
    const { setError, clearError, getError } = useErrorManager();
    
    const axiosInstance = useAxiosPrivate();

    useEffect(() => {
        const fetchGateways = async () => {
            try {
                const response = await axiosInstance.get(listOptions, {
                    withCredentials: true,
                });
                setGateways(response.data);
                clearError('fetch');
                setLoading(false);
            } catch (error) {
                setError('fetch','Failed to fetch gateways');
                setLoading(false);
            }
        };

        fetchGateways();
    }, []);
    
    const handleFilterChange = (event) => {
        setFilterText(event.target.value);
    };

    return (
            <PageContainer>
                {loading ? (
                    <CircularProgress />
                ) : getError('fetch') ? (
                    <Snackbar open={true} autoHideDuration={6000}>
                        <Alert severity="error">{getError('fetch')}</Alert>
                    </Snackbar>
                ) : (
                    <>
                        <TextFilter
                            columns={columns}
                            onFilterChange={handleFilterChange}
                        />
                        <GenericTable
                            items={gateways}
                            columns={columns}
                            filterText={filterText}
                        />
                    </>
                )}
            </PageContainer>
    );
}

export default GatewaysTable;